import React, { RefObject, useEffect } from "react";

type UseClickOutsideProps = {
  refs: Array<React.RefObject<HTMLDivElement> | RefObject<HTMLButtonElement>>;
  handler: (event: Event) => void;
  isDisable?: boolean;
};

const useClickOutside = (props: UseClickOutsideProps) => {
  const { refs = [], handler, isDisable = false } = props;
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!isDisable) {
      const listener = (event) => {
        let isClickedOnRef = false;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < refs.length; i++) {
          if (
            !refs[i].current ||
            (!!refs[i].current && refs[i].current?.contains(event.target))
          ) {
            isClickedOnRef = true;
          }
        }

        if (!isClickedOnRef) {
          handler(event);
        }
      };

      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);

      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }
  }, [refs, handler, isDisable]);
};

export default useClickOutside;
